import { render, staticRenderFns } from "./FinalizeColorUpReview.vue?vue&type=template&id=4801c9ae&scoped=true&"
import script from "./FinalizeColorUpReview.vue?vue&type=script&lang=js&"
export * from "./FinalizeColorUpReview.vue?vue&type=script&lang=js&"
import style0 from "./FinalizeColorUpReview.vue?vue&type=style&index=0&id=4801c9ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4801c9ae",
  null
  
)

export default component.exports